import { useState } from "react"
import { Plus } from "lucide-react"

import AppShell from "@/components/tuw/AppShell"
import { Button } from "@/components/ui/button"
import CapacityStrip from "@/components/tuw/access/CapacityStrip"
import AccessTabs from "@/components/tuw/access/AccessTabs"
import PersonCard from "@/components/tuw/access/PersonCard"
import SharedWithMeRow from "@/components/tuw/access/SharedWithMeRow"
import InviteModal from "@/components/tuw/access/InviteModal"
import AccessEmpty from "@/components/tuw/access/AccessEmpty"

// Atrium item 4 — the customer Access hub: per-order, read-only collaboration
// grants. A single presenter (CustomerAccessPresenter) assembles both tabs, the
// capacity meter, and the invite-modal's grantable orders. Every write is a
// session action that redirects back here, so the page is always server-truth
// (no optimistic state — D-D). The invite modal opens in two modes: fresh
// ("Invite to a project") or locked to a person's email ("Add a project").
export default function Access({ access }) {
  const [tab, setTab] = useState("by")
  const [invite, setInvite] = useState({ open: false, lockedEmail: null })

  const openInvite = (lockedEmail = null) => setInvite({ open: true, lockedEmail })
  const setInviteOpen = (open) => setInvite((state) => ({ ...state, open }))

  return (
    <>
      <div className="mx-auto w-full max-w-[1080px] px-[26px] pt-6 pb-14">
        <div className="mb-[18px] flex items-end justify-between gap-5">
          <div>
            <h1 className="font-display text-2xl font-bold tracking-[-0.4px] text-foreground">Access</h1>
            <p className="mt-1.5 max-w-[540px] text-[13px] leading-[1.5] text-ink-3">
              Share individual projects with trusted collaborators, and open projects others have shared with
              you.
            </p>
          </div>
          <Button className="shrink-0" onClick={() => openInvite(null)}>
            <Plus className="size-4" strokeWidth={2} />
            Invite to a project
          </Button>
        </div>

        <CapacityStrip capacity={access.capacity} />
        <AccessTabs tab={tab} counts={access.counts} onChange={setTab} />

        <div>
          {tab === "by" ? (
            access.sharedByMe.length > 0 ? (
              access.sharedByMe.map((person) => (
                <PersonCard key={person.key} person={person} onAddProject={(p) => openInvite(p.email)} />
              ))
            ) : (
              <AccessEmpty variant="by" onInvite={() => openInvite(null)} />
            )
          ) : access.sharedWithMe.length > 0 ? (
            access.sharedWithMe.map((row) => <SharedWithMeRow key={row.orderId} row={row} />)
          ) : (
            <AccessEmpty variant="with" />
          )}
        </div>
      </div>

      <InviteModal
        open={invite.open}
        onOpenChange={setInviteOpen}
        orders={access.grantableOrders}
        lockedEmail={invite.lockedEmail}
        atCap={access.capacity.atCap}
      />
    </>
  )
}

// `active="Access"` matches the sidebar NAV "Access" key so the rail highlights.
Access.layout = (page) => (
  <AppShell active="Access" crumb={["Account", "Access"]}>
    {page}
  </AppShell>
)
